import { createContext } from 'react'

export interface LanguageContextType {
  currentLanguage: string
  changeLanguage: (lang: 'ja' | 'en') => Promise<void>
  isLoading: boolean
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined)
